import { render, staticRenderFns } from "./integrated.vue?vue&type=template&id=548096cd&scoped=true"
import script from "./integrated.vue?vue&type=script&lang=js"
export * from "./integrated.vue?vue&type=script&lang=js"
import style0 from "./integrated.vue?vue&type=style&index=0&id=548096cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548096cd",
  null
  
)

export default component.exports